export const ERROR_CODE = {
  SUITE_IS_EMPTY: 'suiteIsEmpty',
  CHANNEL_NOT_FOUND: 'channelDoesNotExists',
  RUNNING_QUEUE_IS_FULL_ERROR: 'runningQueueIsFullError',
};
